interface RuntimeConfig {
  apiUrl: string
  turnstileSiteKey: string
}

let cached: RuntimeConfig | null = null

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached
  const res = await fetch('/config.json', { cache: 'no-cache' })
  if (!res.ok) throw new Error(`Failed to load /config.json: ${res.status}`)
  const config = (await res.json()) as RuntimeConfig
  if (!config.apiUrl) throw new Error('config.apiUrl missing')
  if (!config.turnstileSiteKey) throw new Error('config.turnstileSiteKey missing')
  cached = config
  return config
}
